var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"new-benchmarks"},[_c('HeadingWithDescription',{attrs:{"size-heading":32,"text-heading":_vm.labels.title,"text-description":_vm.labels.description}}),_c('FormNewBenchmarks')],1)}
var staticRenderFns = []

export { render, staticRenderFns }